import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../shared/models/api-response.model';
import { HttpCommonService } from '../../../shared/services/http-common-service';
import { SelectList } from '../../../shared/models/select-list';
import { LookupDto, LookupAddEditDto, SearchLookupDto } from '../models/lookup-models';

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  private baseUrlPrefix = '';

  constructor(private httpCommonService: HttpCommonService) { }

  /**
   * Search lookup entities
   * @param entityName The name of the lookup entity (e.g., 'Emirate', 'City', 'CampaignType')
   * @param searchDto Search parameters
   */
  search(entityName: string, searchDto?: SearchLookupDto): Observable<ApiResponse<SearchLookupDto>> {
    return this.httpCommonService.post<ApiResponse<SearchLookupDto>>({
      url: this.baseUrlPrefix + entityName + '/Search',
      body: searchDto
    });
  }

  /**
   * Get lookup entity by ID
   * @param entityName The name of the lookup entity
   * @param id Entity ID
   */
  getById(entityName: string, id: number): Observable<ApiResponse<LookupDto>> {
    return this.httpCommonService.get<ApiResponse<LookupDto>>({
      url: this.baseUrlPrefix + entityName + '/Get/' + id
    });
  }

  /**
   * Insert or update lookup entity
   * @param entityName The name of the lookup entity
   * @param dto Entity data
   */
  insertOrUpdate(entityName: string, dto: LookupAddEditDto): Observable<ApiResponse<number>> {
    return this.httpCommonService.post<ApiResponse<number>>({
      url: this.baseUrlPrefix + entityName + '/Save',
      body: dto
    });
  }

  /**
   * Delete lookup entity
   * @param entityName The name of the lookup entity
   * @param id Entity ID
   */
  delete(entityName: string, id: number): Observable<ApiResponse<number>> {
    return this.httpCommonService.delete<ApiResponse<number>>({
      url: this.baseUrlPrefix + entityName + '/Delete/' + id
    });
  }

  /**
   * Get select list for lookup entity
   * @param entityName The name of the lookup entity
   * @param additionalParam Optional additional parameter (e.g., emirateId for City)
   */
  getSelectList(entityName: string, additionalParam?: number): Observable<ApiResponse<SelectList[]>> {
    let url = this.baseUrlPrefix + entityName + '/GetSelectList';
    if (additionalParam !== undefined && additionalParam !== null) {
      url += '/' + additionalParam;
    }
    return this.httpCommonService.get<ApiResponse<SelectList[]>>({
      url: url
    });
  }
}

